module.exports={
    felton_quantitative_title: 'Felton量化交易机器人',
    felton_quantitative_content1: '基于大数据和人工智能的虚拟货币交易机器人',
    felton_quantitative_content2: '智能构建 让您躺着赚钱',
    start_robot: '启动机器人',
    product_description: '产品介绍',
    smart_contract_transactions: '智能合约交易',
    smart_contract_transactions_tip:'多空对冲震荡套利，风险可控',
    per_year:'年',
   fully_automated_spot_trading:'现货全自动交易',
   fully_automated_spot_trading_tip:'双币种交易套利，适合横盘屯币',
   spot_grid_trading:'现货网格交易', 
   spot_martin_trading:'现货马丁交易',
   spot_martin_trading_tip:'单边加倍押注降低成本，回调止盈',
   golden_triangle: '黄金三角交易',
    stable_income: '收益稳定',
    introduce: '介绍',
    golden_triangle_tip: '三个币种循环交易，活跃度高',
    stability: '稳定性',
    rate_return: '收益率',
    capture_big_market: '捕捉大行情的能力',

    bb_transaction: 'BB交易',
    long_term_profit: '长期收益',
    bb_transaction_tip: '任意两个币种交易，适合横盘屯币',

    ub_transaction: 'UB交易',
    high_return: '高回报',
    ub_transaction_tip: '用USDT交易货币，获得长期理财收益',

    grid_strategy: '网格策略',
    volatility_arbitrage: '震荡套利',
    grid_strategy_tip: '震荡行情自动低买高卖，稳定套利',

    martin_strategy: '马丁策略',
    money_management: '仓位管理',
    martin_strategy_tip: '单边加倍押注拉低成本，止盈回调',

    contract_strategy: '对冲合约交易',
    stay_tuned_for: '收益率高',
    coming_soon: '合约多空对冲亏损，震荡套利，超高收益',

    investment_advice: '产品优势',
    reference_plan: '参考建议',
    product_portfolio : '产品介绍',
    membership_level: '会员等级',
    for_people: '适合人群',
    features: '特点',
    monthly_return: '月收益率',
    turn_on: '创建',
    option_one: '选项一',
    option_one_introduce: '2个“黄金三角交易”\n+\n2个“BB”交易',
    option_one_for_people: '囤币的比特币信仰者',
    option_one_features: '多币种交易，开单量大，收益长期稳定',
    option_two: '选项二',
    option_two_introduce: '1个“黄金三角交易”\n+\n5个“BB”交易',
    option_two_for_people: '囤币的比特币信仰者',
    option_two_features: '适合在平盘交易中获利，不适合剧烈的市场波动',
    option_three: '选项三',
    option_three_introduce: '2个“UB交易”\n+\n1个“BB交易”',
    option_three_for_people: '获得长期理财收益',
    option_three_features: '适合在市场剧烈波动时赚取收益，短期内可能有30%-50%的浮亏',
    no_suitable_solution: '没有合适的解决方案，试试自定义',
    custom_solution: '解决方案？',

    product_advantages: '产品优势',
    exclusive_strategy_model: '独家策略模型',
    exclusive_strategy_model_tip: '智能交易算法和精细化仓位管理，强大的风控系统和灵活的点位捕捉',
    fully_automatic_unattended: '全自动无人值守',
    fully_automatic_unattended_tip: '傻瓜式代理投资，降低时间成本，弥补信息不对称，轻松享受睡后收益',
    financial_security: '资金安全保障',
    financial_security_tip: '支持API接入Binance、Okx等各大交易所，仅调用交易权限，数字资产始终在自己的交易所账户中',
    regularly_update_policy: '定期更新策略',
    regularly_update_policy_tip: '强大的技术策略团队，根据市场变化，定期调整参数、更新策略',

    opening_process: '开通流程',
    choose_exchange_connect: '选择一个交易所并连接',
    recharge_fuel: '充值燃料费',
    quantification_robot:'全自动量化机器人',
    download_now:'立即下载',
    trading_robot:'智能合约交易 | 全自动量化机器人',
    quantitative_robot:'量化交易机器人',
    monthly_income:'月化收益高达',
    cryptocurrency:'百万加密货币投资者信赖',
    add_official:'添加官方电报',
    subscribe:'订阅官方频道',
    download_app:'立即下载App',
    ios_download:'iOS 下载',
    android_download:'Android 下载',
    more_download:'更多下载方式',
    view_more:'查看更多',
    start_robot:'开启机器人',
    view_network_revenue:'查看全网收益',
    register_now:'注册立享永久免费量化工具',
    registernow:'立即注册',
    incognito_browsing:'您开启了“无痕浏览”模式，这将影响您的正常使用，请先切换为普通浏览模式！',
    warn:'警告',
    sure:'确定',
    free_trading_bots:'4款免费交易机器人',
    cryptocurrency_is:'加密货币开创全新时代',
    u_plus_helps:'U plus 助您創造、增值及保管財富',
    top_performance:'顶级性能，极速交易',
    exchange_technology_driven:'交易所技术驱动，超低延迟，极速撮合',
    asset_protection:'资产保障，极致安全',
    asset_protection_tip:'U Plus 符合 CCSS 标准，保障资产及数据安全',
    high_liquidity:'高流动，低点差',
    high_liquidity_tip:'U Plus 合约杠杆交易，超高效率，最小滑点',
    service_24_7:'全天候服务',
    service_24_7_tip:'保证系统正常运行，提供全天候客户服务',
    convenient_and_ease:'便捷易用',
    convenient_and_ease_tip:'提供多种订单系统及交易工具，风险可控',
    trade_with_peace_of_mind:'随时随地，安心交易',
    platform_offers:'U Plus 平台提供PC网页版、手机 Android、iOS App应用程序',
    cryptocurrency_is_era:'加密货币开创全新时代',
    start_your:'60秒开启您的数字货币之旅',
    select_exchange_connect:'选择一个交易所并连接',
    top_up_fuel:'充值燃料',
    users_all_over_the_world:'用户遍布全球',
    more_than_100_countries:'100多个国家和地区',
    total_earnings_network:'全网累计收益',
    total_return_entire_network:'全网累计收益率',
    has_been_operating_stably:'已稳定运营',
    day:'天',
    hours:'小时',
    robot_stability:'机器人稳定性',
    make_wealth_within_reach:'让财富近在咫尺',
    everything_you_need:'您现在需要的一切都在 UPlus 应用程序中',
    ios_profile_download:'iOS 描述文件下载',
    android_download:'Android 下载',
    more_download:'更多下载方式',
    our_partners:'我们的合作伙伴',
    sure:'确 定',
    app_name:'UPLUS智能交易APP',
    app_description:'全新期现策略日进斗金',
    app_description_tip:'速来体验！',
    app_description_tip_note:'注：苹果手机用户需要翻墙使用！',
    purchase_successful:'购买成功，您已升级为',
    go_set_up_the_robot:'去设置机器人',
    your:'您的',
    order_has_not_yet_been_paid:'订单尚未支付',
    to_complete:'去完成',
    see_you_next_time:'下次再说',
    major_upgrade:'重磅升级！',
    all_contract_users:'所有合约用户燃料费/点卡',
    discount:'7折',
    exemptions_are_being_offered:'减免中...',
    live_broadcast:'UPLUS 直播',
    closed:'已关闭',
    incentive_program:'奖励方案',
    level:'级别',
    upgrade_conditions:'升级条件',
    award:'奖励',
    things_to_note:'注意事项：',
    regular_users_enter:'普通用户升级到Lv0后进入奖励系统，规则里的直推用户指Lv0以上用户',
    protection_period:'Lv2、Lv3、Lv4分别有1个月的级别保护期，Lv5、Lv6分别有3个月的级别保护期',
    brokerage_incentive_program:'经纪商奖励方案',
    omni_channel_rewards:'全渠道奖励',
    level_4_and_above:'Lv4以上可以申请成为经纪商，详情请咨询客服。',
    fuel_consumption_30_day:'30天燃料消耗≥30usdt',
    direct_pushes:'个直推',
    deduction_501_2000U:'30天扣费501-2000U',
    deduction_2001_10000U:'30天扣费2001-10000U',
    off_chain_201_500_people:'链下201-500人，30天扣费10001-30000U',
    blockchain_501_1000_people:'链下501-1000人，30天扣费30001-100000U',
    more_than_1001_people:'链下1001人以上，30天扣费大于100000U',
    home:'首页',
    user:'用户中心',
    robotics:'机器人中心',
    return_home:'返佣中心',
    security_center:'安全中心',
    browser_not:'您的浏览器不支持本地存储',
    enter_maximum:'最多只能输入500个字符',
    question_type:'请选择问题类型',
    enter_description:'请输入问题描述',
    sensitive_words:'包含敏感词汇，请重新编辑！',
    images_must:'图片只能是 JPG或者PNG 格式!',
    image_size:'图片大小不能超过 12MB!',
    received_thank:'收到，非常感谢您提的宝贵意见',
    view_tutorial:'查看教程'




}
